import { getDeviceInfo } from '../utils/deviceUtils';

export type ClientShell = 'mobile' | 'pc';

const STORAGE_KEY = 'wavelink:client-shell';

/** 根据设备类型自动选择客户端壳：手机 → 移动版，平板/桌面 → PC 版 */
export function detectClientShell(): ClientShell {
  const { isTablet, isDesktop } = getDeviceInfo();
  if (isTablet || isDesktop) {
    return 'pc';
  }
  return 'mobile';
}

export function getClientShell(): ClientShell {
  if (typeof localStorage === 'undefined') {
    return detectClientShell();
  }
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'pc' || stored === 'mobile') {
    return stored;
  }
  const detected = detectClientShell();
  localStorage.setItem(STORAGE_KEY, detected);
  return detected;
}

export function setClientShell(shell: ClientShell): void {
  if (typeof localStorage === 'undefined') {
    return;
  }
  localStorage.setItem(STORAGE_KEY, shell);
}

/** 按客户端模式返回默认首页路径 */
export function getPathForClientShell(shell: ClientShell): string {
  return shell === 'pc' ? '/radio-remote' : '/';
}

/** 登录成功后应进入的默认路径（读 localStorage） */
export function getPostAuthPath(): string {
  return getPathForClientShell(getClientShell());
}
